import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Row, Col } from 'react-bootstrap';
import { cloneDeep } from 'lodash';
import ArrowButton from '../../../common/button-arrow';
import GameLevelFormColumn from './game-level-form-column';

class GameLevelForm extends Component {
  handleAddColumn = () => {
    const gameLevels = this.gameLevels();
    const level = gameLevels.filter(gameLevel => !gameLevel._destroy).length + 1;
    const { incentive, dispatch } = this.props;
    const newGameLevels = cloneDeep(incentive.game_levels);
    if (level > Object.keys(newGameLevels).length) {
      newGameLevels[`level-${level}`] = {};
      newGameLevels[`level-${level}`]['minimum-number-of-scans'] = { value: 0 };
      newGameLevels[`level-${level}`]['prize-amount'] = { value: 0 };
      newGameLevels[`level-${level}`]['game-link'] = { value: '' };
    } else {
      newGameLevels[`level-${level}`]._destroy = false;
    }

    dispatch(actions.change('deep.incentives.game_levels', newGameLevels));
  }

  handleRemoveColumn = () => {
    const gameLevels = this.gameLevels();
    if (gameLevels.filter(gameLevel => !gameLevel._destroy).length > 0) {
      const level = gameLevels.filter(gameLevel => !gameLevel._destroy).length;
      const { incentive, dispatch } = this.props;
      const newGameLevels = cloneDeep(incentive.game_levels);

      if (newGameLevels[`level-${level}`].id) {
        // eslint-disable-next-line dot-notation
        newGameLevels[`level-${level}`]['_destroy'] = true;
      } else {
        delete newGameLevels[`level-${level}`];
      }

      dispatch(actions.change('deep.incentives.game_levels', newGameLevels));
    }
  }

  isLast = (index) => {
    if (index + 1 === 1) {
      return false;
    }

    return this.gameLevels().length === index + 1;
  }

  gameLevels = () => {
    const { incentive } = this.props;

    if (incentive && incentive.game_levels) {
      return Object.values(incentive.game_levels);
    }

    return [];
  }

  render() {
    const gameLevels = this.gameLevels();
    // eslint-disable-next-line dot-notation

    return (
      <div className="container-fluid">
        <Row>
          {gameLevels.length !== 0 &&
            gameLevels
              // eslint-disable-next-line dot-notation
              .filter(gameLevel => !gameLevel['_destroy'])
              .map((gameLevel, index) => (
                <GameLevelFormColumn
                  key={index}
                  level={index + 1}
                  isLast={this.isLast(index)}
                />
              ))}
        </Row>
        <Row>
          <Col md={2}>
            <ArrowButton
              arrow={false}
              submit={false}
              color="red"
              onClick={this.handleAddColumn}
            >
              Add game level
            </ArrowButton>
          </Col>
          <Col md={2}>
            <ArrowButton
              arrow={false}
              submit={false}
              color='red'
              onClick={this.handleRemoveColumn}
              disabled={gameLevels.length === 0}
            >
              Remove game level
            </ArrowButton>
          </Col>
          <Col md={8}></Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  incentive: state.deep.incentives
});

export default connect(mapStateToProps)(GameLevelForm);
